import React, { Fragment, ReactElement } from 'react';
import * as AdminDashboardSelectors from '../../../../redux/reducers/admin_dashboard_reducer/selectors';
import KPI from './kpi';
import {
  Box,
  Grid,
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Typography,
  Chip,
  Paper,
  Divider,
} from '@material-ui/core';
import useStyles from './styles';
import SimpleKPI from './simpleKpi';
import * as CurrencyUtils from '../../../../utils/currency';

export default function TraderKPIs(): ReactElement {
  const traderDashboardData =
    AdminDashboardSelectors.useGetTraderDashboardData().data;

  const [applicantTypeId, setApplicantTypeId] = React.useState(0);
  const [remainingTime, setRemainingTime] = React.useState(
    applicantTypeId === 6
      ? getRemainingTimeUntilEndOfMonth()
      : getRemainingTimeUntilEndOfQuarter()
  );

  const [previousRemainingTime, setPreviousRemainingTime] = React.useState(
    applicantTypeId === 6
      ? getRemainingTimeUntilEndOfPreviousMonth()
      : getRemainingTimeUntilEndOfPreviousQuarter()
  );

  React.useEffect(() => {
    if (traderDashboardData)
      setApplicantTypeId(traderDashboardData?.applicantTypeId);
  }, [traderDashboardData]);

  React.useEffect(() => {
    const timer = setInterval(() => {
      if (applicantTypeId === 6) {
        setRemainingTime(getRemainingTimeUntilEndOfMonth());
        setPreviousRemainingTime(getRemainingTimeUntilEndOfPreviousMonth());
      } else {
        setRemainingTime(getRemainingTimeUntilEndOfQuarter());
        setPreviousRemainingTime(getRemainingTimeUntilEndOfPreviousQuarter());
      }
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [applicantTypeId]);

  const currentMonthAndQuarterDetails = getCurrentMonthAndQuarterDetails();
  const previousMonthAndQuarterDetails = getPreviousTimePeriods();

  return (
    <Fragment>
      <Grid container alignItems="flex-start" spacing={2}>
        <Row widthInLargeScreen={12} widthInMidScreen={12}>
          <Typography component={'p'} variant={'h5'}>
            Registration
          </Typography>
        </Row>
        <Row widthInLargeScreen={4} widthInMidScreen={4}>
          <div>
            <KPI
              title="Status"
              content={[
                {
                  name: 'Registration Status',
                  value: traderDashboardData?.traderKpis?.registration
                    ?.registrationStatusDesc
                    ? traderDashboardData.traderKpis.registration
                        .registrationStatusDesc
                    : '',
                },
              ]}
            />
          </div>
        </Row>
        <Row widthInLargeScreen={4} widthInMidScreen={4}>
          <div>
            <KPI
              title="Information"
              content={[
                {
                  name: 'Registration Date',
                  value: traderDashboardData?.traderKpis?.registration
                    ?.registrationDate
                    ? traderDashboardData.traderKpis.registration
                        .registrationDate
                    : '',
                },
                {
                  name: 'Commencement Date',
                  value: traderDashboardData?.traderKpis?.registration
                    ?.commencementDate
                    ? traderDashboardData.traderKpis.registration
                        .commencementDate
                    : '',
                },
              ]}
            />
          </div>
        </Row>
        <Row widthInLargeScreen={4} widthInMidScreen={4}>
          <div>
            <KPI
              title={`Submission/Payment Deadline for Previous Period ${
                applicantTypeId == 6
                  ? previousMonthAndQuarterDetails.previousMonth
                  : 'Q' + previousMonthAndQuarterDetails.previousQuarter
              } of  ${
                applicantTypeId == 6
                  ? previousMonthAndQuarterDetails.previousMonthYear
                  : previousMonthAndQuarterDetails.previousQuarterYear
              }`}
              content={[
                {
                  name: 'Next Deadline In',
                  value:
                    (traderDashboardData
                      ? traderDashboardData?.traderKpis?.registration
                          ?.registrationStatusDesc
                      : 'Excluded') != 'Excluded'
                      ? previousRemainingTime.days.toString().padStart(2, '0') +
                        ':' +
                        previousRemainingTime.hours
                          .toString()
                          .padStart(2, '0') +
                        ':' +
                        previousRemainingTime.minutes
                          .toString()
                          .padStart(2, '0') +
                        ':' +
                        previousRemainingTime.seconds
                          .toString()
                          .padStart(2, '0')
                      : '00:00:00:00',
                },
              ]}
            />
          </div>
        </Row>
        <Row widthInLargeScreen={12} widthInMidScreen={12}>
          <Typography component={'p'} variant={'h5'}>
            VAT Returns
          </Typography>
        </Row>
        <Row widthInLargeScreen={4} widthInMidScreen={4}>
          <div>
            <SimpleKPI
              name={'Submitted'}
              description={'The number of VAT Returns that you have Submitted'}
              color={
                (traderDashboardData?.traderKpis?.vat?.countVatReturn
                  ? traderDashboardData.traderKpis.vat.countVatReturn.toString()
                  : '0') ===
                (traderDashboardData?.traderKpis?.vat?.countVatReturn &&
                traderDashboardData?.vatNotSubmitted
                  ? (
                      traderDashboardData.traderKpis.vat.countVatReturn +
                      traderDashboardData.vatNotSubmitted
                    ).toString()
                  : '0')
                  ? 'green'
                  : 'orange'
              }
              value={
                (traderDashboardData?.traderKpis?.vat?.countVatReturn
                  ? traderDashboardData.traderKpis.vat.countVatReturn.toString()
                  : '0'
                ).toString() +
                ' of ' +
                (traderDashboardData?.traderKpis?.vat?.countVatReturn &&
                traderDashboardData?.vatNotSubmitted
                  ? traderDashboardData.traderKpis.vat.countVatReturn +
                    traderDashboardData.vatNotSubmitted
                  : '0'
                ).toString()
              }
              barPercentage={
                traderDashboardData?.traderKpis?.vat?.countVatReturn &&
                traderDashboardData?.vatNotSubmitted
                  ? (traderDashboardData.traderKpis.vat.countVatReturn /
                      (traderDashboardData.traderKpis.vat.countVatReturn +
                        traderDashboardData.vatNotSubmitted)) *
                    100
                  : 0
              }
              iconName={'vatReturnsCounts'}
              showBar={true}
            />
          </div>
        </Row>
        <Row widthInLargeScreen={4} widthInMidScreen={4}>
          <div>
            <SimpleKPI
              name={'VAT Amount Payable'}
              description={
                'The Total Payable VAT Amount calculated by your VAT Returns'
              }
              color={'blue'}
              value={
                traderDashboardData?.traderKpis?.vat?.totalAmountsPayable
                  ? '€' +
                    CurrencyUtils.formatCurrency(
                      traderDashboardData.traderKpis.vat.totalAmountsPayable
                    )
                  : '€0.00'
              }
              barPercentage={
                traderDashboardData?.traderKpis?.vat?.totalAmountsPayable &&
                traderDashboardData?.traderKpis?.vat?.totalAmountsDeclared
                  ? (traderDashboardData.traderKpis.vat.totalAmountsPayable /
                      traderDashboardData.traderKpis.vat.totalAmountsDeclared) *
                    100
                  : 0
              }
              iconName={'vatPayableAmount'}
              showBar={true}
            />
          </div>
        </Row>
        <Row widthInLargeScreen={4} widthInMidScreen={4}>
          <div>
            <KPI
              title={`Submission/Payment Deadline for Current Period ${
                applicantTypeId == 6
                  ? currentMonthAndQuarterDetails.currentMonthName
                  : 'Q' + currentMonthAndQuarterDetails.currentQuarter
              } of  ${
                applicantTypeId == 6
                  ? currentMonthAndQuarterDetails.currentMonthYear
                  : currentMonthAndQuarterDetails.currentQuarterYear
              }`}
              content={[
                {
                  name: 'Next Deadline In',
                  value:
                    (traderDashboardData
                      ? traderDashboardData?.traderKpis?.registration
                          ?.registrationStatusDesc
                      : 'Excluded') != 'Excluded'
                      ? remainingTime.days.toString().padStart(2, '0') +
                        ':' +
                        remainingTime.hours.toString().padStart(2, '0') +
                        ':' +
                        remainingTime.minutes.toString().padStart(2, '0') +
                        ':' +
                        remainingTime.seconds.toString().padStart(2, '0')
                      : '00:00:00:00',
                },
              ]}
            />
          </div>
        </Row>
        <Row widthInLargeScreen={12} widthInMidScreen={12}>
          <Typography component={'p'} variant={'h5'}>
            Payments
          </Typography>
        </Row>
        <Row widthInLargeScreen={4} widthInMidScreen={4}>
          <div>
            <SimpleKPI
              name={'Paid'}
              description={'The Total Amount of Payments that you have made'}
              color={'blue'}
              value={
                traderDashboardData?.traderKpis?.payments?.totalAmountPaid
                  ? '€' +
                    CurrencyUtils.formatCurrency(
                      traderDashboardData.traderKpis.payments.totalAmountPaid
                    )
                  : '€0.00'
              }
              barPercentage={
                traderDashboardData?.traderKpis?.payments?.totalAmountPaid &&
                traderDashboardData?.traderKpis?.vat?.totalAmountsPayable
                  ? (traderDashboardData.traderKpis.payments.totalAmountPaid /
                      traderDashboardData.traderKpis.vat.totalAmountsPayable) *
                    100
                  : 0
              }
              iconName={'paymentsPaid'}
              showBar={true}
            />
          </div>
        </Row>
        <Row widthInLargeScreen={4} widthInMidScreen={4}>
          <div>
            <SimpleKPI
              name={'Allocated'}
              description={
                'The Amount of your Payments that has been Processed and Allocated'
              }
              color={'green'}
              value={
                traderDashboardData?.traderKpis?.payments?.totalAmountAllocated
                  ? '€' +
                    CurrencyUtils.formatCurrency(
                      traderDashboardData.traderKpis.payments
                        .totalAmountAllocated
                    )
                  : '€0.00'
              }
              barPercentage={
                traderDashboardData?.traderKpis?.payments
                  ?.totalAmountAllocated &&
                traderDashboardData?.traderKpis?.payments?.totalAmountPaid
                  ? (traderDashboardData.traderKpis.payments
                      .totalAmountAllocated /
                      traderDashboardData.traderKpis.payments.totalAmountPaid) *
                    100
                  : 0
              }
              iconName={'paymentsAllocated'}
              showBar={true}
            />
          </div>
        </Row>

        <Row widthInLargeScreen={4} widthInMidScreen={4}>
          <div>
            <SimpleKPI
              name={'Pending'}
              description={'The Amount of your Payments that pending.'}
              color={
                (traderDashboardData?.traderKpis?.payments?.paymentAmountPending
                  ? traderDashboardData.traderKpis.payments.paymentAmountPending
                  : 0) > 0
                  ? 'red'
                  : 'green'
              }
              value={
                traderDashboardData?.traderKpis?.payments?.paymentAmountPending
                  ? '€' +
                    CurrencyUtils.formatCurrency(
                      traderDashboardData.traderKpis.payments
                        .paymentAmountPending
                    )
                  : '€0.00'
              }
              barPercentage={
                traderDashboardData?.traderKpis?.payments
                  ?.paymentAmountPending &&
                traderDashboardData?.traderKpis?.payments?.totalAmountPaid
                  ? (traderDashboardData.traderKpis.payments
                      .paymentAmountPending /
                      traderDashboardData.traderKpis.payments.totalAmountPaid) *
                    100
                  : 0
              }
              iconName={'paymentsPending'}
              showBar={true}
            />
          </div>
        </Row>
      </Grid>
    </Fragment>
  );
}

interface IRowProps {
  widthInLargeScreen: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  widthInMidScreen: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  children: ReactElement;
}

const Row = (props: IRowProps): ReactElement => {
  return (
    <Grid
      xl={props.widthInLargeScreen}
      lg={props.widthInLargeScreen}
      md={props.widthInMidScreen}
      xs={12}
      sm={12}
      item
    >
      {props.children}
    </Grid>
  );
};

function getRemainingTimeUntilEndOfMonth() {
  const today = new Date();
  const endOfMonth = new Date(
    today.getFullYear(),
    today.getMonth() + 1,
    0,
    23,
    59,
    59
  ); // Set time to the last second of the current month
  const timeDifference = endOfMonth.getTime() - today.getTime();

  // Calculate remaining days, hours, minutes, and seconds
  const remainingDays = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
  const remainingHours = Math.floor(
    (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const remainingMinutes = Math.floor(
    (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
  );
  const remainingSeconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

  return {
    days: remainingDays,
    hours: remainingHours,
    minutes: remainingMinutes,
    seconds: remainingSeconds,
  };
}

const getCurrentMonthAndQuarterDetails = () => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth(); // 0-11 (January is 0, December is 11)
  const currentYear = currentDate.getFullYear();

  // Determine the current month and year
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const currentMonthName = monthNames[currentMonth];

  // Determine the current quarter and its year
  const currentQuarter = Math.floor(currentMonth / 3) + 1; // Divide the month by 3 and round down, then add 1
  const currentQuarterYear = currentYear; // The quarter's year is the same as the current year

  return {
    currentMonthName,
    currentMonthYear: currentYear,
    currentQuarter,
    currentQuarterYear,
  };
};

function getPreviousTimePeriods() {
  const now = new Date();

  // Array of month names
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  // Get previous month
  const prevMonthDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const prevMonthName = monthNames[prevMonthDate.getMonth()];
  const prevMonthYear = prevMonthDate.getFullYear();

  // Get previous quarter
  const currentMonth = now.getMonth(); // 0-based
  const currentQuarter = Math.floor((currentMonth + 3) / 3);
  const prevQuarter = currentQuarter === 1 ? 4 : currentQuarter - 1;
  const prevQuarterYear = prevQuarter === 4 ? prevMonthYear - 1 : prevMonthYear;

  return {
    previousMonth: prevMonthName,
    previousMonthYear: prevMonthYear,
    previousQuarter: prevQuarter,
    previousQuarterYear: prevQuarterYear,
  };
}

function getRemainingTimeUntilEndOfQuarter() {
  const today = new Date();
  const quarter = Math.floor((today.getMonth() + 3) / 3); // Calculate the current quarter (1, 2, 3, or 4)
  const lastMonthOfQuarter = quarter * 3 + 1; // Calculate the last month of the current quarter
  const endOfQuarter = new Date(
    lastMonthOfQuarter > 12 ? today.getFullYear() + 1 : today.getFullYear(),
    lastMonthOfQuarter > 12 ? 1 : lastMonthOfQuarter,
    0,
    23,
    59,
    59
  ); // Set time to the last second of the current quarter
  const timeDifference = endOfQuarter.getTime() - today.getTime();

  // Calculate remaining days, hours, minutes, and seconds
  const remainingDays = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
  const remainingHours = Math.floor(
    (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const remainingMinutes = Math.floor(
    (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
  );
  const remainingSeconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

  return {
    days: remainingDays,
    hours: remainingHours,
    minutes: remainingMinutes,
    seconds: remainingSeconds,
  };
}

function getRemainingTimeUntilEndOfPreviousMonth() {
  const today = new Date();

  // Determine the end date of the previous month
  let prevMonth = today.getMonth() - 1;
  let prevMonthYear = today.getFullYear();

  // If we're in January, go to December of the previous year
  if (prevMonth < 0) {
    prevMonth = 11; // December
    prevMonthYear -= 1;
  }

  const endOfPreviousMonth = new Date(
    prevMonthYear,
    prevMonth + 1, // Set to the first day of the current month
    0, // The last day of the previous month
    23,
    59,
    59
  );

  const timeDifference = endOfPreviousMonth.getTime() - today.getTime();

  // Calculate remaining days, hours, minutes, and seconds
  const remainingDays = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
  const remainingHours = Math.floor(
    (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const remainingMinutes = Math.floor(
    (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
  );
  const remainingSeconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

  return {
    days: remainingDays >= 0 ? remainingDays : 0,
    hours: remainingHours >= 0 ? remainingHours : 0,
    minutes: remainingMinutes >= 0 ? remainingMinutes : 0,
    seconds: remainingSeconds >= 0 ? remainingSeconds : 0,
  };
}

function getRemainingTimeUntilEndOfPreviousQuarter() {
  const today = new Date();

  // Calculate the current quarter (1, 2, 3, or 4)
  const currentQuarter = Math.floor((today.getMonth() + 3) / 3);

  // Determine the previous quarter
  const previousQuarter = currentQuarter === 1 ? 4 : currentQuarter - 1;
  const yearAdjustment = currentQuarter === 1 ? -1 : 0;

  // Determine the last month of the previous quarter
  const lastMonthOfPreviousQuarter = previousQuarter * 3;

  // Compute end date of the previous quarter
  const endOfPreviousQuarter = new Date(
    today.getFullYear() + yearAdjustment,
    lastMonthOfPreviousQuarter,
    0, // Set to the last day of the previous quarter
    23,
    59,
    59
  );

  // Calculate the time difference between now and the end of the previous quarter
  const timeDifference = endOfPreviousQuarter.getTime() - today.getTime();

  // Calculate remaining days, hours, minutes, and seconds
  const remainingDays = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
  const remainingHours = Math.floor(
    (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const remainingMinutes = Math.floor(
    (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
  );
  const remainingSeconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

  return {
    days: remainingDays >= 0 ? remainingDays : 0,
    hours: remainingHours >= 0 ? remainingHours : 0,
    minutes: remainingMinutes >= 0 ? remainingMinutes : 0,
    seconds: remainingSeconds >= 0 ? remainingSeconds : 0,
  };
}
